import {Modal} from "antd";

const ModalConfirm = ({onOk, title, content, ...props}) => {

    return Modal.confirm({
        title,
        content,
        icon: null,
        okButtonProps: {
            style: {
                backgroundColor: "var(--primary-color)"
            }
        },
        onOk,
        ...props
    })
}

export const ModalMethodCustom = {
    confirm: ModalConfirm
}